var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "v-card",
    { staticClass: "hide-overflow", attrs: { flat: "", height: "100%" } },
    [
      _c(
        "Loading",
        {
          attrs: {
            visible: _vm.loading,
            message: "Caricamento dati...",
            templateType: _vm.loadTemplateCorrente,
          },
        },
        [
          _c(
            "v-layout",
            { staticStyle: { "padding-bottom": "50px" }, attrs: { wrap: "" } },
            [
              _vm.userIsAdmin
                ? _c(
                    "v-flex",
                    {
                      staticStyle: { margin: "24px 24px 0px 24px" },
                      attrs: { xs12: "" },
                    },
                    [
                      _c("v-select", {
                        attrs: {
                          filled: "",
                          clearable: "",
                          "return-object": "",
                          items: _vm.fornitori,
                          "item-text": "nome",
                          label: "Fornitori",
                          hint: "Selezionare fornitore per visualizzare le righe consegna",
                        },
                        model: {
                          value: _vm.fornitore,
                          callback: function ($$v) {
                            _vm.fornitore = $$v
                          },
                          expression: "fornitore",
                        },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
              _c(
                "v-flex",
                { attrs: { xs12: "" } },
                [
                  _c(
                    "v-tabs",
                    {
                      attrs: {
                        dark: "",
                        "slider-color": "yellow",
                        "slider-size": "5",
                        "show-arrows": "",
                      },
                      model: {
                        value: _vm.filtroStatoOrdini,
                        callback: function ($$v) {
                          _vm.filtroStatoOrdini = $$v
                        },
                        expression: "filtroStatoOrdini",
                      },
                    },
                    _vm._l(_vm.stati, function (stato) {
                      return _c(
                        "v-tab",
                        { key: stato, attrs: { "data-test": stato } },
                        [
                          _vm._v(
                            " " +
                              _vm._s(
                                _vm._f("statoLavorazioneDescBreve")(stato)
                              ) +
                              " "
                          ),
                        ]
                      )
                    }),
                    1
                  ),
                ],
                1
              ),
              _c(
                "v-flex",
                { attrs: { xs12: "" } },
                [
                  !_vm.vistaLista
                    ? _c("LavorazioniCards", {
                        attrs: { lavorazioni: _vm.lavorazioni },
                      })
                    : _c("LavorazioniList", {
                        attrs: {
                          "data-test": "lista-lavorazioni",
                          lavorazioni: _vm.lavorazioni,
                        },
                      }),
                ],
                1
              ),
              _c("div", { staticClass: "pagination text-xs-center" }, [
                _c("div", { staticClass: "pagination-text grey--text" }, [
                  _vm._v(" Righe visualizzate: "),
                  _c("strong", [_vm._v(_vm._s(_vm.numTotLavorazioni))]),
                ]),
                _c(
                  "div",
                  { staticClass: "pagination-buttons" },
                  [
                    _c("v-pagination", {
                      attrs: { length: _vm.pageCount, disabled: _vm.loading },
                      model: {
                        value: _vm.page,
                        callback: function ($$v) {
                          _vm.page = $$v
                        },
                        expression: "page",
                      },
                    }),
                  ],
                  1
                ),
              ]),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }